import { render, staticRenderFns } from "./RecoveryPeriodAfterSurgery.vue?vue&type=template&id=eb1bf264&"
import script from "./RecoveryPeriodAfterSurgery.vue?vue&type=script&lang=js&"
export * from "./RecoveryPeriodAfterSurgery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports